export class Tokens {
    accessToken: string;
    refreshToken: string;
}
